module.exports = __webpack_public_path__ + "img/tuanduidefen.537ec13d.svg";